module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "最多添加100个客服",
      "placement": "bottom-start"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addWechatKf
    }
  }, [_vm._v("添加客服")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "share"
    },
    on: {
      "click": _vm.loginWechatKf
    }
  }, [_vm._v("登录微信客服")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.kflist,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "客服头像",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(img) {
        return [(img.row.kf_headimgurl) ? _c('img', {
          attrs: {
            "src": _vm.wximageurl + img.row.kf_headimgurl,
            "height": "40"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kf_nick",
      "label": "昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "绑定微信号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(wx) {
        return [(wx.row.kf_wx) ? _c('div', [_vm._v(" " + _vm._s(wx.row.kf_wx) + " ")]) : (wx.row.invite_wx) ? _c('div', [_vm._v(" " + _vm._s(wx.row.invite_wx))]) : _c('div', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否在线"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(online) {
        return [(online.row.is_online) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("在线")])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("离线")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邀请状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(status) {
        return [(status.row.invite_status === 'waiting') ? _c('div', [_c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("绑定邀请待确认")])], 1) : (status.row.kf_wx) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已绑定")])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未绑定")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editWechatKf(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteWechatKfAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "微信客服",
      "visible": _vm.addWechatKfVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addWechatKfVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.wechatKfFromData
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "客服昵称"
      }
    }, [_c('el-input', {
      model: {
        value: (_vm.wechatKfFromData.nick),
        callback: function($$v) {
          _vm.$set(_vm.wechatKfFromData, "nick", $$v)
        },
        expression: "wechatKfFromData.nick"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "frm-tips"
    }, [_vm._v("客服昵称，最长16个字")])], 1), _vm._v(" "), (_vm.isEdit === false) ? _c('el-form-item', {
      attrs: {
        "label": "客服微信号"
      }
    }, [_c('p', {
      staticClass: "frm-tips"
    }, [_vm._v("请输入需绑定的客服人员微信号")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.wechatKfFromData.wx_name),
        callback: function($$v) {
          _vm.$set(_vm.wechatKfFromData, "wx_name", $$v)
        },
        expression: "wechatKfFromData.wx_name"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "客服头像"
      }
    }, [_c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("只能上传jpg/png文件，且不超过2M")]), _vm._v(" "), _c('el-upload', {
      staticClass: "avatar-uploader",
      attrs: {
        "list-type": "picture",
        "action": "",
        "data": _vm.wechatKfFromData,
        "on-change": _vm.handleChange,
        "show-file-list": false,
        "auto-upload": false
      }
    }, [(_vm.imageUrl) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.imageUrl
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon"
    })])], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.addWechatKfVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), (_vm.isEdit === false) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addWechatKfAction.apply(null, arguments)
        }
      }
    }, [_vm._v("邀请")]) : _c('el-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editWechatKfAction.apply(null, arguments)
        }
      }
    }, [_vm._v("保存")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a5f07f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5f07f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/customservice.vue
// module id = 2630
// module chunks = 0